<template>
  <div>
    <div
      v-if="details && details.item"
      class="details">
      <div class="title">Mã đơn hàng: {{details.item.order_code}}</div>
      <div class="detail">Ngày đặt hàng: {{ details.item.created_at }}</div>
      <div class="detail">Trạng thái: {{ details.item.status !== 1 ? "Mới" : 'Đã thanh toán' }}</div>
    </div>
    <div
      v-if="details && details.receiver"
      class="details">
      <div class="title">Địa chỉ nhận hàng</div>
      <div class="name">{{ details.receiver.full_name }}</div>
      <div class="detail">{{ details.receiver.phone }}</div>
      <div class="detail">{{ details.receiver.address }}</div>
    </div>
    <div
      v-if="details && details.payment_method"
      class="details">
      <div class="title">Phương thức thanh toán</div>
      <div class="detail">{{ details.payment_method.payment_method }}</div>
    </div>
    <div
      v-if="details && details.order && details.order.length > 0"
      class="details">
      <div class="title">Thông tin đơn hàng</div>
      <hr>
      <div class="row">
        <div
          v-for="cart in details.order"
          class="col-sm-6 col-md-4 col-lg-4">
          <history-order-item
            :vatpham="cart"
            :mode="'view'"/>
        </div>
      </div>
      <hr>
      <div class="row mb-1">
        <div class="col-4 text-left">Tổng phải trả</div>
        <div class="col-8 text-right">{{ formatMoneyVND(details.total_amount) }} đ</div>
      </div>
      <div class="row mb-1">
        <div class="col-4 text-left">Phí vận chuyển</div>
        <div class="col-8 text-right">{{ formatMoneyVND(details.transport_fee) }} đ</div>
      </div>
      <div class="row mb-1">
        <div class="col-4 text-left">Tổng tiền</div>
        <div class="col-8 text-right text-red">{{ formatMoneyVND(details.total_amount + details.transport_fee) }} đ</div>
      </div>
      <div class="vat">Đã bao gồm VAT</div>
    </div>
  </div>
</template>
<script>
    import rf from "../../communicate/RequestFactory";
    import {errorToaster} from "../../services/ErrorHandler";
    import HistoryOrderItem from "./HistoryOrderItem";
    import formatMoney from "../../utils/StringUtils";


    export default {
        name: "OrderHistoryDetail",
        components: {
            HistoryOrderItem
        },
        data: function () {
            return {
                details: {}
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.$Progress.start();
                rf.getRequest('OrderHistoryRequest').getOrderDetail(this.$route.params.id, this.$route.query.type).then((res) => {
                    if (res.status === 200) {
                        this.details = res.data;
                    } else {
                        errorToaster('Cố vấn Phong Thủy', res.message);
                    }
                    this.$Progress.finish();
                }).catch(err => {
                    errorToaster('Cố vấn Phong Thủy', 'Xảy ra lỗi kết nối');
                    this.$Progress.fail();
                    this.isGetResult = false;
                })
            },
            formatMoneyVND(money) {
                return formatMoney(money, 0);
            }
        }
    }
</script>

<style lang="scss" scoped>
  .details {
    background-color: white;
    padding: 16px;
    margin-top: 15px;

    .title {
      color: black;
      font-weight: bold;
      font-size: 16px;
    }

    .name {
      color: black;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
    }

    .detail {
      color: #626262;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
    }

    hr {
      border: 1px solid #EFEFEF;
      width: 100%;
    }

    .text-left {
      font-size: 14px;
    }
    .text-right {
      font-size: 14px;
      color: black;
    }

    .text-red {
      color: #ff545b;
    }

    .vat {
      width: 100%;
      text-align: right;
      font-size: 14px;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/history/OrderHistoryDetail.vue